module.exports = __webpack_public_path__ + "media/images/desktop/writer-offering-scenario-development-flow-2959720fb1c0c5d8ba39bdb96d07b82f.png";